'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bytesToSize = require('./bytesToSize');

var _bytesToSize2 = _interopRequireDefault(_bytesToSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (size, message) {
  return function (value) {
    return {
      isValid: (value instanceof Array || value instanceof Object) && value[0] instanceof File && value[0].size <= size,
      message: message || 'File size must be less than ' + (0, _bytesToSize2.default)(size)
    };
  };
};